class Constant {
  static DATE_FORMAT = 'YYYY-MM-DD';
  static DATE_FORMAT_LONG = 'YYYY-MM-DDTHH:mm:ssZ';
  static DEFAULT_CURRENCY_CODE = 'USD';
}

export default Constant;



// WEBPACK FOOTER //
// ./src/common/Constant.js